import { API_HEADER } from "../../util/constants/HEADERS"
import { SendEmail } from "../sendEmail"

export async function registerUser (user: any) {
    return await fetch(`${process.env.REACT_APP_API_URL}user/register`, {
        method: 'POST',
        headers: API_HEADER,
        body: JSON.stringify(user)
    })
    .then((response) => response.json())
    .then(async (result) => {
        if (result.status) {
            await SendEmail(result.data)
        }
        return result
    })
}

export async function loginUser (user: any) {
    return await fetch(`${process.env.REACT_APP_API_URL}user/login`, {
        method: 'POST',
        headers: API_HEADER,
        body: JSON.stringify(user)
    })
    .then((response) => response.json())
    .then(result => {
        return result
    })
    .catch(err => {
        return err
    })
}